// extracted by mini-css-extract-plugin
export var recommendationsListCardContainer = "RecommendationsListCard-module--recommendationsListCardContainer--2A0v-";